module.exports = __webpack_public_path__ + "img/Speaker=Faisal Abid.baa37af3.png";